var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"id":"_mainIframe","src":"https://account.xkw.com/#/index/editPassword?csshref=//zxxkstatic.zxxk.com/usercenter/skins/css/account.css","height":_vm.windowHeight + 'px',"width":"1200px","scrolling":"no","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }